export default {
  serialize() {
    return null
  },
}